<div
  *ngIf="sellers.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header__no-summary">
  <table
    mat-table
    [dataSource]="sellers"
    class="sp-width__full">
    <ng-container matColumnDef="seller_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'SELLERS.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <app-shared-id
          [content]="seller.seller_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.REGISTRATION_DATE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <span class="sp-color__primary sp-text__ellipsized"> {{ seller.created_at | date : 'short' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.NAME_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <span
          *ngIf="seller.seller_firstname && seller.seller_lastname"
          class="sp-color__primary sp-text__ellipsized sp-text__bold">
          {{ getFullName(seller).length > 30 ? (getFullName(seller) | slice : 0 : 30) + '...' : getFullName(seller) }}
        </span>
        <span *ngIf="!seller.seller_firstname || !seller.seller_lastname"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.EMAIL_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ seller.seller_email }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="role">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.ROLE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ seller.seller_role }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.ACTIONS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let seller">
        <div class="sp-row__align">
          <button
            (click)="onSellerDetailClick(seller.seller_id); $event.stopPropagation()"
            mat-icon-button
            class="sp-icon__button sp-icon__button-accent sp-margin__left"
            [matTooltip]="'GENERAL.SEE_DETAILS_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayed_columns"
      class="sp-cursor__pointer"
      (click)="onSellerDetailClick(row.seller_id)"></tr>
  </table>
</div>
